// extracted by mini-css-extract-plugin
module.exports = {"VideoHtml":"VideoHtml_VideoHtml__3BeY4","fadein":"VideoHtml_fadein__13MUl","VideoHtml__hideSeek":"VideoHtml_VideoHtml__hideSeek__38oYd"};